/*WIP: simple component for viewing JSON (currently no pretty-print)*/

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    json: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func,
    readOnly: PropTypes.bool
};

const defaultProps = {
    className: '',
    json: '{}',
    onChange: () => { return; },
    readOnly: false
};

function JsonTextArea(props) {
    let parsedJson;

    if (typeof props.json === 'object') {
        try {
            parsedJson = JSON.stringify(props.json);
        }
        catch(e) {
            parsedJson = 'ERROR: Unable to stringify JSON';
            console.error('JsonTextArea - Uanble to stringify JSON:', props.json);
        }
    }
    else if (typeof props.json === 'string') {
        parsedJson = props.json;
    }
    else {
        parsedJson = 'ERROR: Unable to stringify JSON. (Unknown input type)';
        console.error('JsonTextArea - Uanble to stringify JSON:', typeof props.json, props.json);
    }

    return (
        <textarea className={props.className} readOnly={props.readOnly} onChange={props.onChange} value={parsedJson} />
    );
}

JsonTextArea.propTypes = propTypes;
JsonTextArea.defaultProps = defaultProps;

export default JsonTextArea;